import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';

export default InjectedStyledComponent('div', 'base', 'list', ['firstContent']);
